<template>
  <section class="detail-tab">
    <div class="abs-top-right">
      <v-button
        v-if="isEdit||isGuest"
        type="primary"
        plain
        size="small"
        @click="editClick">Edit Quote</v-button>
    </div>
    <h2>{{productId==80?'Quote Info':'Policy Detail'}}</h2>
    <housemaid-quote-info
      v-if="productId == 12"
      is-quote
      :formData="form" />
    <working-quote-info
      v-else-if="productId == 13"
      is-quote
      :formData="form" />
    <travel-quote-info
      v-else-if="productId == 14"
      is-quote
      :formData="form" />
    <decoration-quote-info
      v-else-if="productId == 15"
      is-quote
      :formData="form" />
    <student-quote-info
      v-else-if="productId == 16"
      is-quote
      :formData="form" />
    <homefire-quote-info
      v-else-if="productId == 17"
      is-quote
      :formData="form" />
    <personal-quote-info
      v-else-if="productId == 18"
      is-quote
      :formData="form" />
    <fire-quote-info
      v-else-if="productId == 20"
      is-quote
      :formData="form" />
    <pet-quote-info
      v-else-if="productId == 22"
      is-quote
      :formData="form"></pet-quote-info>
    <template v-else-if="productId>=80&&!isNewSME">
      <span class="table-tab__title">Quick Quote</span>
      <sme-qucik-info
        :form-data="form"
        :sme-class-id="classId"></sme-qucik-info>
      <span class="table-tab__title">Kyc</span>
      <sme-kyc-info
        :form-data="form"
        :class-id="classId"></sme-kyc-info>
    </template>
    <template v-else-if="isNewSME">
      <new-sme-kyc-info
        :form-data="form"
        is-quote></new-sme-kyc-info>
    </template>
    <template v-else>
      <div class="box">
        <div class="table">
          <div class="tr">
            <span>Effective Date</span>
            <span v-copy="formData.pcy_cmnt_date">
              {{ formData.is_eff_dt_delay?'ASAP':formData.pcy_cmnt_date }}
            </span>
          </div>
          <template v-if="formData.class_id != 14">
            <div class="tr">
              <span>Insurance Type</span>
              <span v-copy="getOptionName('coverTypeOptions', formData.trm_of_cvr)">{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>
            </div>
            <div class="tr">
              <span>Sum Insured </span>
              <span v-copy="formData.isrd_vl">{{ formData.isrd_vl }}</span>
            </div>
            <div class="tr">
              <span>Hire Purchase Owner </span>
              <span v-copy="getOptionName('yesNoOptions', formData.hp_ind)">{{ getOptionName('yesNoOptions', formData.hp_ind) | formatYesNo }}</span>
            </div>
            <div class="tr">
              <span>Name of Hire Purchase Owner  (If Yes for Hire purchase)</span>
              <!--              <span>{{ getLocalAllOptionName('mortgagor', formData.mortgagor) }}</span>-->
              <span
                v-if="!isMortgagorOther"
                v-copy="getLocalAllOptionName('mortgagor', form.mortgagor)">{{ getLocalAllOptionName('mortgagor', form.mortgagor)}}</span>
              <span
                v-else
                v-copy="form.mortgagor_other">{{  form.mortgagor_other}}</span>
            </div>
            <div
              v-if="option_benefits.length>0"
              class="tr">
              <span>Optional Benefits</span>
              <span>
                <span
                  v-for="(item,index) in option_benefits"
                  :key="'extra'+index"
                  v-copy="item.name">{{item.name}}<br></span>
              </span>
            </div>
            <div
              v-if="classId==11&&extraBenefitSelect.length>0"
              class="tr">
              <span>Extra Benefits</span>
              <span>
                <span
                  v-for="(item,index) in extraBenefitSelect"
                  :key="'extra'+index"
                  v-copy="item.name">{{item.name}}<br></span>
              </span>
            </div>
          </template>
        </div>
      </div>
      <div class="box">
        <h1>Policyholder Details</h1>
        <policy-holder-info :form="form" />
      </div>
      <div class="box">
        <!--        <h1>Insured Vehicle</h1>-->
        <h1 v-if="form.class_id == 14">Insured Motorcycle Details</h1>
        <h1 v-if="form.class_id == 11">Insured Private Details</h1>
        <h1 v-if="form.class_id == 12">Insured Commercial Vehicle Details</h1>

        <insured-vehicle-info :form="form" />
      </div>
      <div class="box">
        <h1>Named Driver Information</h1>
        <drivers-info :form="form" />
      </div>
    </template>
    <div
      v-if="productId!=80"
      class="box">
      <h1>Referrer Detail</h1>
      <div class="table">
        <div
          class="tr">
          <span>Referrer</span>
          <span
            v-if="referrer"
            class="flex-column">
            <span
              class="referrer"
              @click="handlerUser(referrer.id)">{{referrer.identity==2?referrer.isrd_com_nm:`${referrer.isrd_lst_nm||''} ${referrer.isrd_fst_nm||''}`}}</span>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="referrer.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </span>
        </div>
        <div
          v-if="form.discount_str"
          class="tr">
          <span>Referrer Discount</span>
          <span>{{form.discount_str}}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import PetQuoteInfo from '@/views/components/modules/pet/pet-quote-info'
import smeKycInfo from '@/views/quoting/sme/component/smeKycInfo'
import smeQucikInfo from '@/views/quoting/sme/component/smeQucikInfo'
import NewSmeKycInfo from '@/views/sme/components/kycInfo'

export default {
  name: 'DetailTab',
  components: {
    PolicyHolderInfo,
    InsuredVehicleInfo,
    DriversInfo,
    HousemaidQuoteInfo,
    DecorationQuoteInfo,
    HomefireQuoteInfo,
    WorkingQuoteInfo,
    PersonalQuoteInfo,
    StudentQuoteInfo,
    TravelQuoteInfo,
    fireQuoteInfo,
    smeKycInfo,
    smeQucikInfo,
    NewSmeKycInfo,
    PetQuoteInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {}
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    productId() {
      return this.form.product_id || 11
    },
    classId() {
      return this.formData.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposes() {
      if(!this.localAllOptions.business_purposes || !this.formData.business_purposes) {
        return []
      }
      return this.localAllOptions.business_purposes.filter(item => {
        return this.formData.business_purposes.includes(item.id)
      })
    },
    isEdit(){
      const {stts} = this.form
      return stts < 401
    },
    isMortgagorOther(){
      let motorList = this.localAllOptions.mortgagor
      let {mortgagor}=this.formData
      let list = motorList.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    option_benefits(){
      let benefitsList = this.localAllOptions.benefits || []
      let arr =[]
      let {benefits=[]} = this.formData||{}
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return benefits.includes(item.id)
        })
      }
      return arr
    },
    isGuest(){
      let {customer} = this.form||{}
      return customer==[]||customer==null||customer==''
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = val
      }
    },
    'formData.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && this.classId == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    }
  },

  methods: {
    ...mapActions('quote', ['updateCarModelOptions']),
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    editClick() {
      this.$emit('edit',true)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.sme-container__info{
  margin-bottom: 30px;
  .box{
    width: 100%;
    max-width: 100%;
  }
}
.detail-tab {
    position: relative;
  .table-tab__title{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding: 20px 0;
    color: #24292E;
    display: inline-block;
    border-top: 1px solid #D1D5DA;
    width: 100%;
  }
  .box {
    margin-bottom: 15px;
    h1 {
        padding-bottom: 10px;
      font-size: 24px;
      color: #616266;
    }
    ul {
      li {
        display: flex;
        padding: 5px;
        list-style: none;
        color: #606266;
        font-size: 12px;
        line-height: 14px;
        border-bottom: 1px solid #dddfe7;
        &:nth-child(2n) {
          background: rgba(0, 0, 0, 0.02);
        }
        span {
          flex: 1;
        }
        span:first-child {
          font-weight: bold;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>


